import React from 'react';

import { SvgComponent } from '@/types/modules/svg.types';

export const Accessibility: SvgComponent = (props) => (
	<svg
		className="w-6 h-6 text-gray-800 dark:text-white"
		aria-hidden="true"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 38 20"
		{...props}
	>
		<path
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="2"
			strokeMiterlimit="10"
			d="M15.4945 13.3423C16.2123 9.61575 13.5761 6.04841 9.60647 5.37453C5.63676 4.70065 1.83676 7.17538 1.11893 10.902C0.401091 14.6286 3.03725 18.1959 7.00694 18.8698C10.9766 19.5436 14.7766 17.069 15.4945 13.3423Z"
		/>
		<path
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="2"
			strokeMiterlimit="10"
			d="M34.862 16.9916C37.7145 14.3138 37.7145 9.97212 34.862 7.29428C32.0095 4.61643 27.3846 4.61643 24.5321 7.29428C21.6796 9.97212 21.6796 14.3138 24.5321 16.9916C27.3846 19.6695 32.0095 19.6695 34.862 16.9916Z"
		/>
		<path
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="2"
			strokeMiterlimit="10"
			d="M22.6575 9.87085C22.1907 9.40488 21.6274 9.03354 21.002 8.77978C20.3766 8.52595 19.7025 8.39502 19.0212 8.39502C18.3399 8.39502 17.6658 8.52595 17.0404 8.77978C16.415 9.03354 15.8517 9.40488 15.3849 9.87085"
		/>
		<path
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="2"
			strokeMiterlimit="10"
			d="M9.62888 1L4.77258 6.11109"
		/>
		<path
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="2"
			strokeMiterlimit="10"
			d="M28.42 1L33.2764 6.11109"
		/>
	</svg>
);